import { useReducer, useCallback, useRef } from 'react';

import keyValueReducer from '@chronos/ui-toolkit/reducers/keyValueReducer';
import { setState } from '@chronos/ui-toolkit/actions';
import * as timeUtil from '@chronos/time-util';

import { useGlobalInterval } from '.';

export const initialState = {
  cardId: null,
  timer: 0,
  // It used to rerender paused component to display proper paused time
  dummyTicker: 0,
  delay: null,
  startTime: null,
  pauseStartTime: null,
  pauseTrackedSeconds: 0,
  isTimerRunning: null,
  timerStatus: null,
  trackingWorklogComment: null,
};

const useTimer = (dummyUpdate = 0) => {
  const [state, dispatch] = useReducer(keyValueReducer, initialState);
  const internalTicker = useRef(0);

  const syncTimer = useCallback((cardTimerState) => {
    if (cardTimerState === null || cardTimerState === undefined) {
      dispatch(
        setState({
          ...initialState,
          isTimerRunning: false,
        })
      );
    } else {
      const pauseSeconds =
        cardTimerState.pauseTrackedSeconds +
        (cardTimerState.pauseStartTime
          ? (+new Date() - cardTimerState.pauseStartTime) / 1000
          : 0);

      const timer =
        Number.parseInt(
          ((cardTimerState.pauseStartTime || +new Date()) -
            cardTimerState.startTime) /
            1000,
          10
        ) - (cardTimerState.pauseTrackedSeconds || 0);

      dispatch(
        setState({
          isTimerRunning: ['run', 'pause'].includes(cardTimerState.timerStatus),
          pauseStartTime: cardTimerState.pauseStartTime,
          pauseTrackedSeconds: cardTimerState.pauseTrackedSeconds,
          pauseStr: timeUtil.stj(pauseSeconds),
          isPauseMinute: pauseSeconds >= 60,
          timer,
          startTime: cardTimerState.startTime,
          timerStatus: cardTimerState.timerStatus,
          delay: cardTimerState.timerStatus === 'run' ? 1000 : null,
          cardId: cardTimerState.cardId,
          boardId: cardTimerState.boardId,
          trackingWorklogComment: cardTimerState.trackingWorklogComment,
        })
      );
    }
  }, []);

  useGlobalInterval(
    (restart) => {
      internalTicker.current += 1;
      const isEveryDummyUpdate = internalTicker.current % dummyUpdate === 0;
      if (isEveryDummyUpdate) {
        const pauseSeconds =
          state.pauseTrackedSeconds +
          (state.pauseStartTime
            ? (+new Date() - state.pauseStartTime) / 1000
            : 0);
        dispatch(
          setState({
            dummyTicker: state.dummyTicker + 1,
            pauseStr: timeUtil.stj(pauseSeconds),
            isPauseMinute: pauseSeconds >= 60,
          })
        );
      }

      if (state.delay) {
        const isEvery5econds = (state.timer + 1) % 5 === 0;
        if (isEvery5econds) {
          const now = +new Date();
          const timer =
            Number.parseInt(
              ((state.pauseStartTime || now) - (state.startTime || now)) / 1000,
              10
            ) - (state.pauseTrackedSeconds || 0);
          const timer3SecondsLag = timer - (state.timer + 1) >= 3;
          if (timer3SecondsLag) {
            dispatch(
              setState({
                timer,
              })
            );
            // Why do i need to restart?
            restart();
            return null;
          }
        }
        dispatch(
          setState({
            timer: state.timer + 1,
          })
        );
      }
      return null;
    },
    dummyUpdate > 0 ? 1000 : state.delay
  );

  return [
    {
      state,
    },
    {
      dispatch,
      syncTimer,
    },
  ];
};

export default useTimer;
